// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Textarea-module__wrapper___ZTwyi","input":"Textarea-module__input___SHOyH","errors":"Textarea-module__errors___3gZxu","extra":"Textarea-module__extra___9T94d"};